import * as yup from "yup";

export const PROMOTION_NAME_MAX_LENGTH = 50;
export const PROMOTION_VENUE_MAX_LENGTH = 100;

export const clampFieldLength = (value, max) =>
  String(value ?? "").slice(0, max);

export const setClampedField = (formik, field, max) => (event) => {
  formik.setFieldValue(field, clampFieldLength(event.target.value, max));
};

export const cappedTextSchema = (max, message, { required } = {}) => {
  const schema = yup.string().trim();
  return (required ? schema.required(required) : schema).max(max, message);
};

export const stripHtml = (value = "") =>
  String(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

export const normalizeLocationUrl = (value = "") => {
  const trimmed = String(value).trim();
  if (!trimmed) return "";
  return /^(https?:)?\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
};

export const isValidLocationUrl = (value = "") => {
  const trimmed = String(value).trim();
  if (!trimmed) return true;
  try {
    const parsed = new URL(normalizeLocationUrl(trimmed));
    return (
      (parsed.protocol === "http:" || parsed.protocol === "https:") &&
      parsed.hostname.includes(".")
    );
  } catch {
    return false;
  }
};

export const locationUrlSchema = () =>
  yup
    .string()
    .trim()
    .test(
      "location-url",
      "Enter a valid location URL",
      (value) => isValidLocationUrl(value)
    );

export const promotionLocationHref = (value) => {
  const raw = String(value || "").trim();
  if (!raw || !isValidLocationUrl(raw)) return "";
  return normalizeLocationUrl(raw);
};

export const inviteHasEventTime = (invite) => invite?.hasEventTime !== false;

export const getMissingInviteSendFields = (invite) => {
  const missing = [];
  if (!String(invite?.venue || "").trim()) missing.push("Venue Address");
  if (!inviteHasEventTime(invite)) missing.push("Time");
  return missing;
};

export const inviteSendBlockedMessage = (missing = []) => {
  if (!missing.length) return "";
  const list =
    missing.length === 1
      ? missing[0]
      : `${missing.slice(0, -1).join(", ")} and ${missing[missing.length - 1]}`;
  return `Please enter the ${list.toLowerCase()} before sending this invite.`;
};
